/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import { graphql, useStaticQuery } from 'gatsby';
import { getSrc } from 'gatsby-plugin-image';
import React from 'react';
import Helmet from 'react-helmet';
import { LanguageContext } from './LanguageProvider';

type SEOProps = {
  description?: string;
  lang?: string;
  title: string;
  image?: string;
};

const SEO: React.FC<SEOProps> = ({ description, lang, title, image }) => {
  const { site, standardImage } = useStaticQuery(query);
  const { language } = React.useContext(LanguageContext);

  const metaDescription = description || site.siteMetadata.description;
  const imageURL = image || getSrc(standardImage);
  const imageParsed = imageURL
    ? imageURL.startsWith('https://cdn.sanity.io')
      ? imageURL
      : `https://om.entur.no${imageURL}`
    : '';

  const getLanguage = () => lang ?? language;

  return (
    <Helmet
      htmlAttributes={{
        lang: getLanguage(),
      }}
      title={title}
      titleTemplate={`%s | ${site.siteMetadata.title}`}
      meta={[
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:image`,
          content: imageParsed,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: title,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
      ]}
    >
      <script
        key="cmp"
        id="usercentrics-cmp"
        src="https://web.cmp.usercentrics.eu/ui/loader.js"
        data-settings-id="RoiEGGOV97ZS8j"
      ></script>
      {/* <!-- Start Humany - implementation: "europa---one-widget" [V4 compatible] --> */}
      <script>{`
        (function(a,b,c,d,e,f,g){for(var h,i=/[?&]{1}(humany[^=]*)=([^&#]*)/g;h=i.exec(a.location.search);)c+=(-1<c.indexOf("?")?"&":"?")+h[1]+"="+h[2];
        f=b.createElement(e),f.async=!0,f.src=c,g=b.getElementsByTagName(e)[0],g.parentNode.insertBefore(f,g),a[d]=a[d]||{_c:[],
        configure:function(){a[d]._c.push(arguments)}};var j=d.toLowerCase();a[j]=a[j]||{_c:[],configure:function(){a[j]._c.push(arguments)}}})
        (window,document,"//entur.humany.net/europa---one-widget/embed.js","Humany","script");
        
        window.humany.configure((config) => { config('europa').routing({ basePath: '/tog-i-europa/informasjon-om-tog-i-europa-beta', mode: 'scopedHash' }) });
      `}</script>
      {/* <!-- End Humany --> */}
      {/* Kunnskapsportal lightbox widget */}
      {/* <script>{`
  (function(a,b,c,d,e,f,g){for(var h,i=/[?&]{1}(humany[^=]*)=([^&#]*)/g;h=i.exec(a.location.search);)c+=(-1<c.indexOf("?")?"&":"?")+h[1]+"="+h[2];
  f=b.createElement(e),f.async=!0,f.src=c,g=b.getElementsByTagName(e)[0],g.parentNode.insertBefore(f,g),a[d]=a[d]||{_c:[],
  configure:function(){a[d]._c.push(arguments)}};var j=d.toLowerCase();a[j]=a[j]||{_c:[],configure:function(){a[j]._c.push(arguments)}}})
  (window,document,"//entur.humany.net/default/embed.js","Humany","script");
`}</script> */}

      {/* *Chatbot */}
    </Helmet>
  );
};

export default SEO;

const query = graphql`
  {
    site {
      siteMetadata {
        title
        description
        author
      }
    }
    standardImage: file(
      relativePath: { eq: "Reisende/Forside/Reisetogiutlandet.jpg" }
    ) {
      childImageSharp {
        gatsbyImageData(
          width: 700
          quality: 50
          placeholder: BLURRED
          layout: CONSTRAINED
        )
      }
    }
  }
`;
